import { Box, Grid, CardMedia, List, Drawer, IconButton } from "@mui/material";
import { useState, useEffect } from "react";
import { UseMenu } from "./UseMenu";
import MenuListRenderer from "./MenuListRenderer";
import MenuRender from "./MenuRender";
import useBreakpoints from "../../hooks/useBreakpoints";
import MenuIcon from "@mui/icons-material/Menu";
import { rsOpenDrawer } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CloseIcon from "@mui/icons-material/Close";

export default function MenuCom() {
  const { getMenu } = UseMenu();
  const [pages, setPages] = useState();
  const [pageViews, setPageViews] = useState();
  const { isSmall } = useBreakpoints();
  const [openDrawer, setOpenDrawer] = useRecoilState(rsOpenDrawer);

  useEffect(() => {
    getMenu((menus) => {
      // console.log(menus);
      setPages(menus);
    });
  }, []);

  useEffect(() => {
    if (pages) {
      setPageViews(
        pages.map((elem, i) => {
          if (elem.pages.length == 1) {
            return <MenuRender model={elem.pages[0]} key={i} />;
          } else {
            return <MenuListRenderer model={elem} key={i} />;
          }
        }),
      );
    }
  }, [pages]);

  return isSmall ? getSmall() : getLarge();

  function getSmall() {
    return (
      <Drawer
        PaperProps={{ elevation: 2 }}
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Grid
          sx={{
            width: "70vw",
            display: "flex",
            height: "100%",
            overflowY: "auto",
          }}
          item
          // xs={2}
        >
          <IconButton
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 2000,
            }}
            onClick={() => setOpenDrawer(false)}
          >
            <CloseIcon sx={{ fill: "#fff" }} />
          </IconButton>
          <Box
            bgcolor={"primary.main"}
            color="#FFFFFF"
            sx={{ height: "100%", overflowY: "auto", width: "100%" }}
          >
            <CardMedia
              sx={{ width: "50%", mx: "auto", pt: 2 }}
              component="img"
              src={window.ENV.logo1}
              alt="Paella dish"
            />
            <List
              sx={{
                "&& .Mui-selected, && .Mui-selected:hover": {
                  backgroundColor: "#ffffff6b",
                },
                overflow: "auto",
                width: "100%",
                mt: 2,
              }}
            >
              {pageViews}
            </List>
          </Box>
        </Grid>
      </Drawer>
    );
  }

  function getLarge() {
    return (
      <Grid
        sx={{
          display: "flex",
          height: "100%",
          overflowY: "auto",
        }}
        item
        xs={2}
      >
        <Box
          bgcolor={"primary.main"}
          color="#FFFFFF"
          sx={{ height: "100%", overflowY: "auto", width: "100%" }}
        >
          <CardMedia
            sx={{ width: "50%", mx: "auto", pt: 2 }}
            component="img"
            src={window.ENV.logo1}
            alt="Paella dish"
          />
          <List
            sx={{
              "&& .Mui-selected, && .Mui-selected:hover": {
                backgroundColor: "#ffffff6b",
              },
              overflow: "auto",
              width: "100%",
              mt: 2,
            }}
          >
            {pageViews}
          </List>
        </Box>
      </Grid>
    );
  }
}
